import { useContext } from 'react';
import { ParamsContext } from 'providers/ParamsContext';

const useGlobalParams = () => {
  const params = useContext(ParamsContext);
  return params;
};

export { useGlobalParams };
